import React from 'react';
import { SwitchElement, SwitchSlider } from './TopupSwitch.styles';
import { useTranslation } from 'react-i18next';

import { ISwitchProps } from '@epi-models/pages/Transfer';
import { Box, IconTooltip, InfoIcon } from 'edenred-ui';

export const TopupSwitch = ({ checked, onChange }: ISwitchProps) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      gap={2}
      mt={7}
    >
      <SwitchElement id="switch-topup-form">
        <SwitchSlider onClick={onChange} checked={checked} />
      </SwitchElement>
      <div id="switch-topup-form-text">
        {t(
          'containers.deposit_money.topup_tab.form.employees.on_hold_employees'
        )}
      </div>
      <div id="switch-topup-form-tooltip">
        <IconTooltip
          title={t(
            checked
              ? 'containers.deposit_money.topup_tab.form.employees.notification_on'
              : 'containers.deposit_money.topup_tab.form.employees.notification_off'
          )}
          placement="top"
        >
          <InfoIcon />
        </IconTooltip>
      </div>
    </Box>
  );
};
